import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DecisionChange } from "../models";
import { ConfigurationService } from ".";

@Injectable({ providedIn: "root" })
export class DecisionService {
  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService,
  ) {}

  post(regionId: number, productId: number, changeValues: any[]) {
    return this.http
      .post(`api/decision`, { regionId, productId, changeValues })
      .pipe((s) => {
        return s;
      });
  }

  postChanges(decisionChanges: DecisionChange[]) {
    return this.http.post(`api/decisionchanges`, decisionChanges).pipe((s) => {
      return s;
    });
  }

  validate() {
    return this.http.post(`api/decision/validate`, null).pipe((s) => {
      return s;
    });
  }

  release() {
    return this.http.post(`api/decision/release`, null).pipe((s) => {
      return s;
    });
  }

  createTestDecision(name: string) {
    return this.http
      .post(`api/decision/createtest/${encodeURI(name)}`, null)
      .pipe((s) => {
        return s;
      });
  }

  getTestDecisions(): any {
    return this.http.get(`api/decision/tests`).pipe((s) => {
      return s;
    });
  }

  setTestDecision(id: number) {
    return this.http
      .post(`api/decision/settestdecision/${id}`, null)
      .pipe((s) => {
        return s;
      });
  }

  setTeamDecision() {
    return this.http.post(`api/decision/setteamdecision`, null).pipe((s) => {
      return s;
    });
  }

  runModel() {
    return this.http.post(`api/decision/runmodel`, null).pipe((s) => {
      return s;
    });
  }
}
